module.exports = __webpack_public_path__ + "img/32.0bae98af.jpg";